import _regeneratorRuntime from "D:\\workFile\\qingbeiCode\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { if (i % 2) { var source = arguments[i] != null ? arguments[i] : {}; ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(arguments[i])); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(arguments[i], key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import PackageCourse from "./components/PackageCourse.vue";
import CourseSoldOut from "../../components/CourseSoldOut.vue";
import CourseShowTeacher from "../../components/rich/CourseShowTeacher";
export default {
  name: "PackageDetail",
  components: {
    PackageCourse: PackageCourse,
    CourseSoldOut: CourseSoldOut,
    CourseShowTeacher: CourseShowTeacher
  },
  data: function data() {
    return {
      id: this.$route.params.id,
      detail: {},
      isSet: false,
      showModal: false,
      hasServiceMore: false,
      courseTabs: [{
        id: 1,
        name: "包含课程"
      }],
      tabs: [{
        id: 1,
        name: "课程详情"
      }],
      courseDefaultCount: 6,
      showMore: true
    };
  },
  computed: {
    navigates: function navigates() {
      return this.$store.state.navigates;
    },
    nav: function nav() {
      var _this = this;

      var nav = this.navigates.filter(function (n) {
        return n.id == _this.$route.query.nav;
      })[0];

      if (nav && nav.url != "/index") {
        nav = _objectSpread({}, nav);
        var url = nav.url;

        if (url.indexOf("?") < 0) {
          url += "?";
        } else {
          url += "&";
        }

        url += "nav=" + nav.id;
        nav.url = url;
        return nav;
      }

      return {
        name: "课程包",
        url: "/package"
      };
    },
    courses: function courses() {
      if (!this.detail.package_course_items) {
        return [];
      }

      if (!this.showMore) {
        return this.detail.package_course_items;
      }

      return this.detail.package_course_items.slice(0, this.courseDefaultCount);
    },
    hasApply: function hasApply() {
      var items = this.detail.package_course_items;

      if (this.detail.packageCourseStatus == 1) {
        return true;
      }

      if (!items || items.length == 0) {
        return false;
      }

      for (var i = 0, len = items.length; i < len; i++) {
        var item = items[i];

        if (item.packageCourseStatus != 1) {
          return false;
        }
      }

      return true;
    },
    teachers: function teachers() {
      console.log(45, this.detail.teacherList);
      return this.detail.teacherList.map(function (item) {
        return _objectSpread({
          teacher_name: item.real_name,
          teacher_id: item.id
        }, item);
      });
    }
  },
  watch: {
    detail: function detail() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.setServiceMore();
      });
    }
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var _this3 = this;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$http.get("/api/app/packageCourse/" + this.id);

            case 2:
              this.detail = _context.sent;
              this.$nextTick(function () {
                _this3.setServiceMore();
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    setServiceMore: function setServiceMore() {
      if (!this.$refs.services) {
        return;
      }

      if (this.$refs.services.clientHeight > 20) {
        this.hasServiceMore = true;
      } else {
        this.hasServiceMore = false;
      }
    },
    goToBuy: function goToBuy() {
      this.$router.push({
        name: "OrderConfirm",
        query: {
          package_id: this.id,
          order_type: 8,
          // type: 7,
          shop_infos: JSON.stringify(this.detail.package_course_items.filter(function (course) {
            return course.packageCourseStatus == 2;
          }).map(function (course) {
            return {
              shop_id: course.course_id,
              shop_type: course.course_type
            };
          }))
        }
      });
    }
  }
};